import React, { useEffect } from "react"
import classnames from "classnames"

import DeviceWrapper from "containers/DeviceWrapper/DeviceWrapper"
import ContentHeader from "components/ContentHeader/ContentHeader"
import DeviceSection from "components/DeviceSection/DeviceSection"
import DeviceLinks from "components/DeviceLinks/DeviceLinks"

import { updateMeta, restoreDefaultMeta } from "helpers/meta"
import { getAssetURL } from "helpers/static"

import styles from "./pageHisense.css"
import i18n from "consts/i18n"

const headerImage = getAssetURL("image.pageHisense.headerImage")
const headerImage_2x = getAssetURL("image.pageHisense.headerImage_2x")
const tvImage = getAssetURL("image.pageHisense.tvImage")
const tvImage_2x = getAssetURL("image.pageHisense.tvImage_2x")
const tvImage2 = getAssetURL("image.pageHisense.tvImage2")
const tvImage2_2x = getAssetURL("image.pageHisense.tvImage2_2x")
const tvImage3 = getAssetURL("image.pageHisense.tvImage3")
const tvImage3_2x = getAssetURL("image.pageHisense.tvImage3_2x")
const tvImage4 = getAssetURL("image.pageHisense.tvImage4")
const tvImage4_2x = getAssetURL("image.pageHisense.tvImage4_2x")
const tvImage5 = getAssetURL("image.pageHisense.tvImage5")
const tvImage5_2x = getAssetURL("image.pageHisense.tvImage5_2x")

const PageHisense = () => {
  useEffect(() => {
    updateMeta({
      title: "Molotov Source TV sur les téléviseurs Hisense | Molotov",
      description: "Molotov Source TV : la télé sans décodeur disponible directement sur les Smart TV Hisense ",
    })
    return () => restoreDefaultMeta()
  }, [])

  return (
    <DeviceWrapper downloadText={i18n.devices.downloadTexts.basic}>
      <div className={classnames(styles.wrapper, styles.headerWrapper)}>
        <ContentHeader
          title={
            <span>
              La télé sans décodeur avec <i>Molotov Source TV</i> sur les Smart TV Hisense
            </span>
          }
          subTitle={
            <div>
              <p className={styles.headerParagraph}>
                Avec <i>Molotov Source TV</i> sur vos Smart TV Hisense Vidaa4, <br />
                accédez à tous vos programmes télé directement et simplement et
                <br />
                découvrez une nouvelle expérience télé sans décodeur !
              </p>
            </div>
          }
          image={{
            src: headerImage,
            srcSet: `${headerImage} 1x, ${headerImage_2x} 2x`,
            width: 524,
          }}
          imageAlt="Molotov Source TV sur les Smart TV Hisense"
          headerCustomStyle={styles.header}
        />
      </div>

      <div className={styles.sectionLight}>
        <DeviceSection
          srcSet={[tvImage, `${tvImage_2x} 2x`]}
          imageCustomStyle={styles.tv}
          imageAlt="Tv sans décodeur"
          textCustomStyle={styles.tvText}
          title={
            <span>
              Accès à la télé sans décodeur, directement
              <br />
              sur la TV
            </span>
          }
          customStyle={classnames(styles.sectionLight, styles.tvSection)}
        >
          <p className={DeviceSection.description}>Regardez 34 chaînes dont la TNT, et accédez à plus de 150 chaînes payantes pour tous les goûts.</p>
          <p className={DeviceSection.description}>
            Découvrez les fonctions les plus innovantes du marché : start-over, timeshift, suivi des personnalités.
          </p>
          <p className={DeviceSection.description}>Le tout, directement sur votre Smart TV Hisense Vidaa4. </p>
        </DeviceSection>
      </div>

      <DeviceSection
        srcSet={[tvImage2, `${tvImage2_2x} 2x`]}
        imageCustomStyle={styles.install}
        imageAlt="Faites des économies"
        textCustomStyle={styles.installText}
        title={<span>Faites des économies: accès gratuit, pas de frais de location </span>}
        reverse={true}
        customStyle={styles.sectionDark}
      >
        <p className={DeviceSection.description}>
          <i>Molotov Source TV</i> est accessible gratuitement, et l'offre gratuite donne accès à 34 chaînes dont la TNT.
          <br />
          <br />
          <br />
          <br />
          <br />
        </p>
      </DeviceSection>

      <div className={styles.sectionLight}>
        <DeviceSection
          srcSet={[tvImage3, `${tvImage3_2x} 2x`]}
          imageCustomStyle={styles.tv}
          imageAlt="Une seule télécommande"
          textCustomStyle={styles.tvText}
          title={<span>Moins de câbles encombrants, une seule télécommande</span>}
          customStyle={classnames(styles.sectionLight, styles.tvSection)}
        >
          <p className={DeviceSection.description}>Moins de câbles disgracieux : il est plus facile d’accrocher votre TV design au mur.</p>
          <p className={DeviceSection.description}>
            Expérience fluide : vous avez une seule télécommande pour tout contrôler : changer de chaîne, monter le son...
            <br />
            <br />
            <br />
            <br />
          </p>
        </DeviceSection>
      </div>

      <DeviceSection
        srcSet={[tvImage4, `${tvImage4_2x} 2x`]}
        imageCustomStyle={styles.install}
        imageAlt="Accès aux applications du Store Vidaa"
        textCustomStyle={styles.installText}
        title={<span>Accès aux application du Store Vidaa de votre Smart TV Hisense </span>}
        reverse={true}
        customStyle={styles.sectionDark}
      >
        <p className={DeviceSection.description}>
          <i>Molotov Source TV</i> est compatible avec l'écosystème de votre Smart TV Hisense : vous continuez à profiter de tous vos services vidéos
          comme Netflix, Youtube, etc.
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </p>
      </DeviceSection>

      <div className={styles.sectionLight}>
        <DeviceSection
          srcSet={[tvImage5, `${tvImage5_2x} 2x`]}
          imageCustomStyle={styles.tv}
          imageAlt="Disponible sur tous les téléviseurs"
          textCustomStyle={styles.tvText}
          title={<span>Disponible sur tous les téléviseurs du foyer</span>}
          customStyle={classnames(styles.sectionLight, styles.tvSection)}
        >
          <p className={DeviceSection.description}>
            Grâce au multi-écran, <i>Molotov Source TV</i> peut être installé sur tous les appareils de la maison : mobile, tablette, ordinateur… et
            tous les téléviseurs du foyer, sans décodeur.
            <br />
            <br />
            <br />
            <br />
            <br />
          </p>
        </DeviceSection>
      </div>

      <DeviceLinks />
    </DeviceWrapper>
  )
}

export default PageHisense
